export const resendVerificationLinkErrors = [
    'Failed to resend Verification Email',
    'The email address cannot be null or empty.',
    'Please provide a valid email address.'
];
